import { render, staticRenderFns } from "./interface_tree_table.vue?vue&type=template&id=67d90f60&"
import script from "./interface_tree_table.vue?vue&type=script&lang=js&"
export * from "./interface_tree_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports